import { Component, effect, inject, input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { ReferComponent } from '../../modals/refer/refer.component';
import { AnalyticsService } from '../../services/analytics.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { PopupService } from '../../services/popup.service';
import { CHAINS, convertNum } from '../../shared/constants/app-enums';
import { ICounter } from '../../shared/interfaces/common.interface';

@Component({
  selector: 'app-round-user-details',
  templateUrl: './round-user-details.component.html',
  styleUrl: './round-user-details.component.scss',
  standalone: false,
})

// This component is used to show the Round timer, User purchased details, Round title etc
export class RoundAndUserDetails {
  // Values to be taken from widget component
  readonly liveCounter = input<ICounter>({
    _days: 0,
    _hours: 0,
    _minutes: 0,
    _seconds: 0,
    _diff: 0,
  });
  readonly raisedInfo = input<{
    usdRaised: number;
    raisedPercent: string;
    userStaked: number;
    userEthClaimable: number;
    userClaimable: number;
    maxAmount: number;
  }>({
    raisedPercent: '',
    usdRaised: 0,
    userClaimable: 0,
    userEthClaimable: 0,
    userStaked: 0,
    maxAmount: 0,
  });

  tokenName = environment.tokenName;
  modalRef!: BsModalRef<ReferComponent>;
  walletAddress: string = '';

  private readonly dataService = inject(PresaleDataService);
  private readonly popupService = inject(PopupService);
  private readonly translate = inject(TranslateService);
  private readonly modalService = inject(BsModalService);
  private readonly analyticService = inject(AnalyticsService);

  constructor() {
    effect(() => {
      this.dataService.walletAddressSignal();
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress;
    });
  }

  convertNum(amount: number) {
    if (!amount) return 0;
    return convertNum(amount);
  }

  yourPurchasedInfo() {
    this.popupService.messagePopup({
      icon: 'info',
      desc: this.translate.instant('popup.your_purchased_popup_info'),
      confirmBtnTxt: this.translate.instant('misc.ok'),
    });
  }

  stakeInfo() {
    this.popupService.messagePopup({
      icon: 'info',
      desc: this.translate.instant('staking.stake_popup_info'),
      confirmBtnTxt: this.translate.instant('misc.ok'),
    });
  }

  get referUrl() {
    return this.analyticService.referUrl;
  }

  // get isReferalAvailable() {
  //   return this.dataService.isReferalAvailable;
  // }

  referAndEarn(): void {
    this.modalRef = this.modalService.show(ReferComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static',
      // initialState: { url: this.referUrl },
    });
  }


}
